import Cookies from 'js.cookie';
import * as types from '../../../constants/types'
import objectAssign from 'object-assign';
import * as nav from '../../../lib/nav'

const COOKIE_PATH = 'QA_USER';
const COOKIE_PATH_EMAIL = 'QA_USER_EMAIL';

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function storeCurrentUser(res) {
  const { token } = res;
    Cookies.set(COOKIE_PATH, token);
    return res;
}

export function storeCurrentEmail(res) {
    Cookies.set(COOKIE_PATH_EMAIL, res.userinfo.email);
    return res;
}

export function getCurrentUser() {
    const currentUser = Cookies.get(COOKIE_PATH);
    if (currentUser) {
      return currentUser;
    }
    return null;
}

export function getCurrentUserEmail() {
  const email = Cookies.get(COOKIE_PATH_EMAIL);
  if (email) {
    return email;
  }
  return null;
}

export function logoutUser() {
    Cookies.remove(COOKIE_PATH);
    Cookies.remove(COOKIE_PATH_EMAIL);
    return {
      type: types.USER_LOGGED_OUT
    };
  }

export function handleAuthResponse(response) {
    const token = response.headers.get('Authorization');
        return objectAssign({}, response, {
        token
    });
}

export function handleErrors(response) {
    if (!response.ok) {
      if (response.status === 401) {
        Cookies.remove(COOKIE_PATH);
        Cookies.remove(COOKIE_PATH_EMAIL);
        return nav.routeToLogin();
      }
      throw Error(response.statusText);
    }
    return response;
  }

export function hasError(response) {
    return (
      response === null ||
      (response.is_alert && response.alert_type !== 'success')
    );
}

export function showCustomError(response) {
    if (response === null) {
      return {
        type: types.HIDE_CUSTOM_ERROR,
      };
    }
    return {
      type: types.SHOW_CUSTOM_ERROR,
      error: response,
    };
  }

export function onServerError(err) {
    return {
        type: types.SERVER_ERROR,
        err,
    };
}